import { useGiftForm } from '../../../../components/GiftFormContext';
import { useTokenSearch } from '../../../../hooks/useTokenSearch';
import styled, { useTheme } from 'styled-components';
import TextInput from '../../../../components/Inputs/Text';
import { hapticsImpactLight } from '../../../../common/haptic';
import TokenList from '../../../../components/TokenList';
import {
  EVENT_GIFT_FLOW_TOKEN_SELECTED,
  sendEvent,
} from '../../../../common/analytics';
import { useSearchParams } from 'react-router-dom';
import { useMemo } from 'react';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex: 1;
  min-height: 0;
`;

const TokenSelector = ({ onContinue, isModal = false }) => {
  const { setValue } = useGiftForm();
  const theme = useTheme();

  const {
    searchTerm,
    displayTokens,
    isLoading,
    isFetching,
    hasMore,
    setSearchTerm,
    loadMore,
  } = useTokenSearch(null, null);

  const [searchParams] = useSearchParams();
  const lpd = searchParams.get('lpd');

  const NETFLIX_PRIORITY_TOKEN = 'XsEH7wWfJJu2ZT3UCFeVfALnVA6CP5ur7Ee11KmzVpL';

  const sortedTokens = useMemo(() => {
    // This is gonna put netflix token at the to as long as the token is in the list
    if (lpd === 'netflix') {
      return [...displayTokens].sort((a, b) => {
        const aIsPriority = a.address === NETFLIX_PRIORITY_TOKEN;
        const bIsPriority = b.address === NETFLIX_PRIORITY_TOKEN;
        if (aIsPriority && !bIsPriority) return -1;
        if (!aIsPriority && bIsPriority) return 1;
        return 0;
      });
    }
    return displayTokens;
  }, [displayTokens, lpd]);

  const handleTokenSelect = (token) => {
    hapticsImpactLight();
    setValue('targetTokenAddress', token.address);
    setValue('network', token.network);
    sendEvent(EVENT_GIFT_FLOW_TOKEN_SELECTED, {
      token: token.address,
      network: token.network,
    });
    // Auto-advance to next step when token is selected
    if (onContinue) {
      // Small delay to ensure form state is updated
      setTimeout(() => {
        onContinue();
      }, 100);
    }
  };

  // Always show the full token list - same UI for both modal and embedded mode
  return (
    <Container>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        <label
          style={{ color: theme.text.title, fontSize: 14, fontWeight: 500 }}
        >
          Select an Asset to Gift
        </label>
        <TextInput
          placeholder='Search asset'
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
      <TokenList
        tokens={sortedTokens}
        isLoading={isLoading}
        isFetching={isFetching}
        hasMore={hasMore}
        loadMore={loadMore}
        onTokenSelect={handleTokenSelect}
      />
    </Container>
  );
};

export default TokenSelector;
